import { useTranslation } from 'react-i18next';
import type { FormRule } from 'antd';
import { Form, Select } from 'antd';
import type { TTransportType } from 'api/swagger';
import { TrailerSubTypes, TransportType, TruckSubTypes } from 'types/transport';

interface ITransportSubTypeInputProps {
  type: TTransportType;
  validationRule: FormRule[];
}

export const TransportSubTypeInput: React.FC<ITransportSubTypeInputProps> = (props) => {
  const { type, validationRule } = props;

  const { t } = useTranslation();
  const subTypes = type === TransportType.truck ? TruckSubTypes : TrailerSubTypes;

  return (
    <Form.Item name='subType' label={t('transport:sub_type')} rules={validationRule}>
      <Select placeholder={t('transport:sub_type')} disabled={!type}>
        {Object.entries(subTypes).map(([key, value]) => (
          <Select.Option key={key} value={key}>
            {value}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
